export const ringBells = () => {
  const bell1 = document.getElementById('jingle-bell-one');
  const bell2 = document.getElementById('jingle-bell-two');
  bell1.play();
  setTimeout(() => {
    bell2.play();
  }, 300); // 300 roughly aligns the bells so its like someone shaking it twice
}